import { Action, Dispatcher } from '../Dispatcher'
import { ActionType, ActionData } from './ActionTypes'

export class ActionCreator {

    static identitySelection(merchantId: string, terminalId: string) {
        this.dispatchAction(ActionType.IDENT_SELECTION, new ActionData.IdentitySelectionData(merchantId, terminalId));
    }

    static toggleSendResponses(merchantId: string, terminalId: string, value: boolean) {
        this.dispatchAction(ActionType.TOGGLE_RESPONSES, new ActionData.ToggleResponseData(merchantId, terminalId, value));
    }

    static webApiResponse(key: ActionType, data: any, params: any) {
        this.dispatchAction(key, new ActionData.WebApiResponse(data, params));
    }

    static createMerchantTermianlFolders(merchantId: string, terminalId: string) {
        this.dispatchAction(ActionType.CREATE_FOLDERS, new ActionData.IdentitySelectionData(merchantId, terminalId));
    }

    static saveConfiguration(merchantId: string, terminalId: string, configuration: IConfigurationData) {
        this.dispatchAction(ActionType.SAVE_CONFIGURATION, new ActionData.ConfigurationData(merchantId, terminalId, configuration));
    }

    static deleteConfiguration(merchantId: string, terminalId: string, configuration: IConfigurationData) {
        this.dispatchAction(ActionType.DELETE_CONFIGURATION, new ActionData.ConfigurationData(merchantId, terminalId, configuration));
    }

    static closeModal() {
        this.dispatchAction(ActionType.MODAL_CLOSE);
    }

    static closeYesNoModal() {
        this.dispatchAction(ActionType.YESNO_MODAL_CLOSE);
    }

    static downloadConfigurationFiles(merchantId: string, terminalId: string) {
        this.dispatchAction(ActionType.DOWNLOAD_CONFIGURATION_FILES, new ActionData.ConfigurationFilesDownload(merchantId, terminalId));
    }

    static uploadConfigurationFiles(merchantId: string, terminalId: string, file: any) {
        this.dispatchAction(ActionType.UPLOAD_CONFIGURATION_FILES, new ActionData.ConfigurationFilesUpload(merchantId, terminalId, file));
    }

    // Helper methods
    private static dispatchAction(actionType: ActionType, data?: ActionData.Base) {
        var action: Action =
            {
                actionType: actionType,
                data: data
            }

        Dispatcher.dispatch(action);
    }
}


// WEBPACK FOOTER //
// ./Scripts/actions/ActionCreator.ts